import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 32px;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 24px;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const TitleText = styled.h1`
  margin: 0;
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DescriptionText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const LocationPill = styled.div`
  border: 1px solid ${(props) => props.theme.colors.davysGrey};
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
`;

export const CanvasActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const CanvasWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 200px;
`;

export const EmptyStateCard = styled.section`
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  width: 100%;
  flex: 1;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const IconHighlight = styled.div`
  width: 40px;
  height: 40px;
  padding: 8px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.titanWhite};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateTitle = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

export const EmptyStateDescription = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
`;
